var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "userView" } },
    [
      _c("v-breadcrumbs", { attrs: { items: _vm.breadcrumbs, divider: "-" } }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("list-sessions", {
                attrs: {
                  sessions: _vm.sessions,
                  breadcrumbs: _vm.breadcrumbs,
                  title: _vm.displayName
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("activity-view", {
                attrs: {
                  user: _vm.userID,
                  title: _vm.activityTitle,
                  "user-name": _vm.displayName
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }